<template>
    <div class="field">
        <input type="checkbox" 
            :name="switchId" 
            :id="switchId" 
            class="switch is-rounded is-success is-medium" 
            v-model="val"
            @input="sendData($event)">

        <label :for="switchId">{{ switchLabel }}</label>
    </div>
</template>

<script>

export default {
    name: 'SwitchInput',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        switchLabel: {
            type: String,
            default: 'label for switch'
        },
        switchId: {
            type: String,
            required: true
        },
        trueValue: {
            default: '1'
        },
        falseValue: {
            default: '0'
        }
    },
    computed:{
        val: {
            get(){
                return this.value
            },
            set(){
                return !this.val
            }
        }
    },
    methods: {
        sendData(event){
            const returnValue = event.target.checked ? this.trueValue : this.falseValue
            this.$emit('change', this.switchId, returnValue)
        }
    }
}

</script>

<style lang="scss">

</style>